import type { Recipe } from '../../domain/recipe';

// DE: Ukrainische Abendessen für vier Portionen, ohne Fleisch; Fleisch nur als Beilage.
// EN: Ukrainian dinners for four portions without meat; meat only as an add-on.
// prettier-ignore
export const UKRAINIAN_RECIPES: readonly Recipe[] = [
  {
    id: 'borscht', name: 'Борщ з квасолею', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Borschtsch mit Bohnen',
    activeMinutes: 30, totalMinutes: 70, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_thighs', quantityPerPortion: 150 },
    ingredients: [
      { productId: 'beetroot', quantity: 400 }, { productId: 'cabbage', quantity: 400 }, { productId: 'carrot', quantity: 150 },
      { productId: 'onion', quantity: 150 }, { productId: 'tomato_paste', quantity: 70 }, { productId: 'kidney_beans', quantity: 800 },
      { productId: 'broth', quantity: 2 }, { productId: 'sour_cream', quantity: 200 }, { productId: 'dill', quantity: 1 },
      { productId: 'garlic', quantity: 10 }, { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Зварити бульйон з кубиків (1,5 л) і капусту в ньому 10 хвилин.',
      'Обсмажити цибулю, моркву й тертий буряк, додати томатну пасту.',
      'Додати засмажку й квасолю в каструлю, варити 20 хвилин.',
      'Додати часник і кріп, подавати зі сметаною.',
    ],
    stepsDe: [
      'Aus Brühwürfeln 1,5 l Brühe kochen und den Kohl darin 10 Minuten garen.',
      'Zwiebel, Karotte und geriebene Rote Bete anbraten, Tomatenmark dazugeben.',
      'Das Gemüse und die Bohnen in den Topf geben und 20 Minuten kochen.',
      'Knoblauch und Dill dazugeben, mit Schmand servieren.',
    ],
  },
  {
    id: 'buckwheat_mushrooms', name: 'Гречка з грибами та яйцем', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Buchweizen mit Pilzen und Ei',
    activeMinutes: 15, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'buckwheat', quantity: 240 }, { productId: 'mushrooms', quantity: 600 },
      { productId: 'onion', quantity: 150 }, { productId: 'eggs', quantity: 4 }, { productId: 'oil', quantity: 30 },
    ],
    steps: [
      'Зварити гречку (20 хвилин).',
      'Обсмажити цибулю й гриби.',
      'Зварити яйця або підсмажити їх, змішати все з гречкою.',
    ],
    stepsDe: [
      'Buchweizen kochen (20 Minuten).',
      'Zwiebel und Pilze anbraten.',
      'Eier kochen oder braten und alles mit dem Buchweizen vermengen.',
    ],
  },
  {
    id: 'zucchini_fritters', name: 'Оладки з кабачків з фетою та сметаною', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Zucchinipuffer mit Feta und Schmand',
    activeMinutes: 25, totalMinutes: 35, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'zucchini', quantity: 1000 }, { productId: 'eggs', quantity: 4 }, { productId: 'flour', quantity: 80 },
      { productId: 'feta', quantity: 200 }, { productId: 'sour_cream', quantity: 200 }, { productId: 'dill', quantity: 1 },
      { productId: 'oil', quantity: 40 },
    ],
    steps: [
      'Натерти кабачки, посолити й відтиснути сік.',
      'Додати яйця, борошно, покришену фету й кріп.',
      'Смажити невеликі оладки по 3 хвилини з кожного боку, подавати зі сметаною.',
    ],
    stepsDe: [
      'Zucchini reiben, salzen und den Saft ausdrücken.',
      'Eier, Mehl, zerbröselten Feta und Dill dazugeben.',
      'Kleine Puffer von jeder Seite 3 Minuten braten und mit Schmand servieren.',
    ],
  },
  {
    id: 'lazy_golubtsi', name: 'Ліниві голубці з сочевицею', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Faule Kohlrouladen mit Linsen',
    activeMinutes: 20, totalMinutes: 50, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'mince_mixed', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'cabbage', quantity: 800 }, { productId: 'lentils', quantity: 260 }, { productId: 'carrot', quantity: 150 },
      { productId: 'onion', quantity: 150 }, { productId: 'tomato_paste', quantity: 70 }, { productId: 'sour_cream', quantity: 200 },
      { productId: 'broth', quantity: 1 },
    ],
    steps: [
      'Нашаткувати капусту, обсмажити з цибулею та морквою.',
      'Додати сочевицю, томатну пасту й 700 мл бульйону.',
      'Тушкувати під кришкою 30 хвилин, подавати зі сметаною.',
    ],
    stepsDe: [
      'Kohl in feine Streifen schneiden und mit Zwiebel und Karotte anbraten.',
      'Linsen, Tomatenmark und 700 ml Brühe dazugeben.',
      'Zugedeckt 30 Minuten schmoren und mit Schmand servieren.',
    ],
  },
  {
    id: 'fish_potato_bake', name: 'Минтай, запечений з картоплею та броколі', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Seelachs aus dem Ofen mit Kartoffeln und Brokkoli',
    activeMinutes: 15, totalMinutes: 45, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'pollock', quantity: 800 }, { productId: 'potato', quantity: 500 }, { productId: 'broccoli', quantity: 500 },
      { productId: 'onion', quantity: 150 }, { productId: 'sour_cream', quantity: 200 }, { productId: 'cheese', quantity: 80 },
      { productId: 'dill', quantity: 1 },
    ],
    steps: [
      'Нарізати картоплю тонкими скибками, викласти у форму з цибулею.',
      'Зверху покласти рибу й броколі, змастити сметаною з кропом.',
      'Посипати сиром і запікати 30 хвилин при 200 °C.',
    ],
    stepsDe: [
      'Kartoffeln in dünne Scheiben schneiden und mit der Zwiebel in eine Auflaufform legen.',
      'Fisch und Brokkoli darauflegen und mit Schmand und Dill bestreichen.',
      'Mit Käse bestreuen und 30 Minuten bei 200 °C backen.',
    ],
  },
  {
    id: 'fish_soup', name: 'Юшка з минтаю з горошком', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Fischsuppe mit Seelachs und Erbsen',
    activeMinutes: 15, totalMinutes: 40, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'pollock', quantity: 800 }, { productId: 'potato', quantity: 400 }, { productId: 'carrot', quantity: 200 },
      { productId: 'onion', quantity: 150 }, { productId: 'peas', quantity: 300 }, { productId: 'broth', quantity: 2 },
      { productId: 'dill', quantity: 1 }, { productId: 'sour_cream', quantity: 200 },
    ],
    steps: [
      'Зварити картоплю, моркву й цибулю в 1,5 л бульйону (15 хвилин).',
      'Додати рибу шматками й горошок, варити 10 хвилин.',
      'Посипати кропом і подавати зі сметаною.',
    ],
    stepsDe: [
      'Kartoffeln, Karotte und Zwiebel in 1,5 l Brühe kochen (15 Minuten).',
      'Fisch in Stücken und Erbsen dazugeben und 10 Minuten kochen.',
      'Mit Dill bestreuen und mit Schmand servieren.',
    ],
  },
  {
    id: 'bean_stew', name: 'Квасоля, тушкована з овочами та фетою', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Geschmorte Bohnen mit Gemüse und Feta',
    activeMinutes: 15, totalMinutes: 30, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'sausages', quantityPerPortion: 75 },
    ingredients: [
      { productId: 'kidney_beans', quantity: 800 }, { productId: 'carrot', quantity: 200 }, { productId: 'onion', quantity: 150 },
      { productId: 'paprika', quantity: 500 }, { productId: 'tomato_paste', quantity: 70 }, { productId: 'feta', quantity: 200 },
      { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Обсмажити цибулю, моркву й перець.',
      'Додати квасолю, томатну пасту й трохи води, тушкувати 15 хвилин.',
      'Подавати з покришеною фетою.',
    ],
    stepsDe: [
      'Zwiebel, Karotte und Paprika anbraten.',
      'Bohnen, Tomatenmark und etwas Wasser dazugeben und 15 Minuten schmoren.',
      'Mit zerbröseltem Feta servieren.',
    ],
  },
  {
    id: 'cabbage_stew', name: 'Тушкована капуста з грибами та яйцем', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Geschmorter Kohl mit Pilzen und Ei',
    activeMinutes: 15, totalMinutes: 40, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'sausages', quantityPerPortion: 75 },
    ingredients: [
      { productId: 'cabbage', quantity: 1000 }, { productId: 'mushrooms', quantity: 400 }, { productId: 'carrot', quantity: 150 },
      { productId: 'onion', quantity: 150 }, { productId: 'tomato_paste', quantity: 50 }, { productId: 'eggs', quantity: 8 },
      { productId: 'oil', quantity: 40 },
    ],
    steps: [
      'Обсмажити цибулю, моркву й гриби.',
      'Додати нашатковану капусту й томатну пасту, тушкувати 25 хвилин.',
      'Подавати з вареними яйцями.',
    ],
    stepsDe: [
      'Zwiebel, Karotte und Pilze anbraten.',
      'Fein geschnittenen Kohl und Tomatenmark dazugeben und 25 Minuten schmoren.',
      'Mit gekochten Eiern servieren.',
    ],
  },
  {
    id: 'lavash_roll', name: 'Рол з лаваша з хумусом, яйцем і копченим лососем', cuisine: 'ukrainian', meal: 'dinner',
    nameDe: 'Lavash-Rolle mit Hummus, Ei und Räucherlachs',
    activeMinutes: 10, totalMinutes: 10, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'lavash', quantity: 200 }, { productId: 'hummus', quantity: 200 }, { productId: 'eggs', quantity: 6 },
      { productId: 'smoked_salmon', quantity: 100 }, { productId: 'cucumber', quantity: 1 },
      { productId: 'tomato', quantity: 300 }, { productId: 'lettuce', quantity: 1 },
    ],
    steps: [
      'Зварити яйця й нарізати їх разом з огірком і помідорами.',
      'Змастити лаваш хумусом, викласти салат, яйця, лосось і овочі.',
      'Щільно згорнути й розрізати навпіл.',
    ],
    stepsDe: [
      'Eier kochen und mit Gurke und Tomaten klein schneiden.',
      'Lavash mit Hummus bestreichen, Salat, Eier, Lachs und Gemüse darauflegen.',
      'Fest aufrollen und halbieren.',
    ],
  },
];
